module.exports = __webpack_public_path__ + "img/boletin.dd505c75.jpg";